const CardSkeletonLoader = ({
  width = "100%",
  height = "20px",
  borderRadius = "4px",
  className = "",
  count = 1,
}) => {
  return (
    <div className={`box-skeleton-container ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="box-skeleton-item"
          style={{
            width,
            height,
            borderRadius,
            marginBottom: index === count - 1 ? "0" : "8px",
          }}
        >
          <div className="box-skeleton-shimmer"></div>
        </div>
      ))}
    </div>
  );
};

export default CardSkeletonLoader;
